import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NavigationState {
  sidebarOpen: boolean;
  currentRoute: string;
  breadcrumbs: Breadcrumb[];

  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
  setCurrentRoute: (route: string) => void;
  setBreadcrumbs: (breadcrumbs: Breadcrumb[]) => void;
}

export interface Breadcrumb {
  label: string;
  path?: string;
}

export const useNavigationStore = create<NavigationState>()(
  persist(
    (set) => ({
      sidebarOpen: true,
      currentRoute: '/brc/overview',
      breadcrumbs: [],

      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
      setCurrentRoute: (route) => set({ currentRoute: route }),
      setBreadcrumbs: (breadcrumbs) => set({ breadcrumbs }),
    }),
    {
      name: 'riskmetrica-brc-navigation',
      partialize: (state) => ({
        sidebarOpen: state.sidebarOpen,
      }),
    }
  )
);
